module.exports = __webpack_public_path__ + "img/40_37.67db8932.png";